import React, { ComponentType, VoidFunctionComponent } from 'react';
import { WixPatternsProviderEssentials } from './CairoProviderEssentials';

type ExtractProps<C> = C extends ComponentType<infer P> ? P : never;

/**
 * @deprecated
 * use `withWixPatternsProvider`
 */
export function withCairoProvider<C extends VoidFunctionComponent<any>>(
  WrappedComponent: C,
): C {
  return ((props: ExtractProps<C>) => (
    <WixPatternsProviderEssentials>
      <WrappedComponent {...props} />
    </WixPatternsProviderEssentials>
  )) as C;
}

export const withWixPatternsProvider = withCairoProvider;
